import { useMemo } from 'react';

const setRef = (
  ref,
  value,
) => {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};

export const useForkRef = (
  refA,
  refB,
) => {
  const forkRef = useMemo(() => {
    if (refA == null && refB == null) return null;

    return (refValue) => {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);

  return forkRef;
};
